<template>
    <section class="assessmentSection">
        <div class="welcomeBackground"></div>
        <div class="pageContent">
            <div class="pageCompleted">Congratulations! You added an area of concern.</div>
            <div class="pageTitle">
                <span v-if="!hasTotalProtection">Do you want to add another area of concern?</span>
                <span v-if="hasTotalProtection">{{ protectedQty }} of {{ accesibleQty }} areas added.</span>
            </div>
            <div class="pageText">
                <p v-if="!hasTotalProtection">
                    If you do not want to add any more areas, you can continue to view your completed security system.
                </p>
                <p v-if="hasTotalProtection">
                    Total level protection means that all accessible areas are protected. Looks like you have {{ accesibleQty - protectedQty }} more to go!
                </p>
            </div>
            <button class="button"
                    @click="reset">Add another area of concern</button>
            <button class="button continue-button-override width-auto"
                    v-if="!hasTotalProtection"
                    @click="goToSystem">
                Continue to my system
            </button>
        </div>
    </section>
</template>


<script>
import { mapActions, mapState } from 'vuex'
export default {
    computed: {
        ...mapState(['lead']),

        hasTotalProtection() {
            if (this.lead) {
                return this.lead.protectionLevel === 'Total'
            }
            return false
        },

        protectedQty() {
            if (this.lead) {
                return this.lead.areasOfConcern.length
            }

            return 0
        },

        accesibleQty() {
            if (this.lead) {
                return this.lead.accessibleAreasQty
            }
            return 0
        }
    },
    methods: {
        ...mapActions([]),
        goToSystem() {
            mixpanel.track("completedAreasOfConcern")
            this.$parent.resetArea()
            this.$router.push('/assessment/loading')
        },
        reset() {
            this.$parent.resetArea()
        }
    },
    mounted() {}
}
</script>
